module.exports = __webpack_public_path__ + "img/funding-gbp-currency.79d2530.svg";